import type { ContentPort } from '../../application';
import type { CountryCode, CountryPack } from '../../domain';

/**
 * A content port opened only when it is first asked for. The country pack is the heaviest thing
 * the app holds, and the first screen needs none of it: it is fetched once, the first time a part
 * of the wishes is resolved, and kept from then on.
 */
export class LazyContentPort implements ContentPort {
  private port: Promise<ContentPort> | null = null;

  constructor(private readonly open: () => Promise<ContentPort>) {}

  load(country: CountryCode): Promise<CountryPack> {
    this.port ??= this.open();
    return this.port.then((port) => port.load(country));
  }
}
